import React from 'react';
import { FlagsProvider } from '@atlaskit/flag';
import AppBody from 'components/navigation/AppBody';
import ErrorBoundary from 'modules/error-info/ErrorBoundary';
import I18nProvider from 'modules/i18n/I18nProvider';
import NotificationWrapper from 'modules/meta/notificationFlag/notificationWrapper';
import { CommerceSharedComponentIntegrations } from 'modules/shared-components';

import AppSwitcher from './AppSwitcher';

const App = () => (
  <I18nProvider>
    <ErrorBoundary>
      <CommerceSharedComponentIntegrations>
        <FlagsProvider>
          <NotificationWrapper>
            <AppBody mode="light">
              <ErrorBoundary>
                <AppSwitcher />
              </ErrorBoundary>
            </AppBody>
          </NotificationWrapper>
        </FlagsProvider>
      </CommerceSharedComponentIntegrations>
    </ErrorBoundary>
  </I18nProvider>
);

export default App;
